export const apolloURL = process.env.REACT_APP_ADMIN_GRAPHQL_URL;
